import { QueryHookOptions, useQuery } from '@apollo/client';
import {
  COMPANY_DETAILS_SERVICE,
  COMPANY_MODEL_PREVIEW_SERVICE,
  SERIES_FUNDAMENTAL_SERVICE,
  CompanyDetailsService,
  CompanyModelPreviewService,
  SeriesFundamentalService
} from 'application/services';

export const useCompanyServices = () => {
  const useCompanyDetails = (
    options?: QueryHookOptions<CompanyDetailsService.Response, CompanyDetailsService.Params>
  ) =>
    useQuery<CompanyDetailsService.Response, CompanyDetailsService.Params>(
      COMPANY_DETAILS_SERVICE,
      {
        fetchPolicy: 'no-cache',
        ...options
      }
    );

  const useCompanyModelPreview = (
    options?: QueryHookOptions<
      CompanyModelPreviewService.Response,
      CompanyModelPreviewService.Params
    >
  ) =>
    useQuery<CompanyModelPreviewService.Response, CompanyModelPreviewService.Params>(
      COMPANY_MODEL_PREVIEW_SERVICE,
      {
        fetchPolicy: 'no-cache',
        ...options
      }
    );

  const useSeriesFundamental = (
    options?: QueryHookOptions<SeriesFundamentalService.Response, SeriesFundamentalService.Params>
  ) =>
    useQuery<SeriesFundamentalService.Response, SeriesFundamentalService.Params>(
      SERIES_FUNDAMENTAL_SERVICE,
      {
        fetchPolicy: 'no-cache',
        ...options
      }
    );

  return {
    companyDetails: useCompanyDetails,
    companyModelPreview: useCompanyModelPreview,
    seriesFundamental: useSeriesFundamental
  };
};
